import React from 'react';
import './TableBoundaries.css';

export const validBoundaries = (ranks, count) => [...new Set(
  (Array.isArray(ranks) ? ranks : []).filter(rank => Number.isInteger(rank) && rank > 0 && rank < count)
)].sort((a, b) => a - b);
export const boundaryClass = (ranks, position, count) => validBoundaries(ranks, count).includes(position) ? ' standings-row--boundary' : '';

export function BoundaryNote({ranks, count}) {
  const shown = validBoundaries(ranks, count);
  if (!shown.length) return null;
  return <p className="standings-boundary-note">Tabellstreck efter plats {shown.join(', ')} enligt seriens inställningar.</p>;
}
